import gql from 'graphql-tag';

export const GET_MERCHANTS = gql`
  query GetMerchantsList($params: MerchantSearchInput!, $package: String!) {
    merchantList(params: $params) {
      result {
        merchantName
        logo
        activeCampaign
        firstLiveDate
        hasAccountDetails
        brandAssets(package: $package) {
          image {
            icon {
              path
            }
          }
          color {
            primaryColor {
              value
            }
            secondaryColor {
              value
            }
          }
        }

        offerNetworkExternalVenueId
        totalCashback
        totalTransactions

        percentAuthsThatFailedToClear {
          visa
          mastercard
          amex
        }

        percentDroppedTrend {
          visa
          mastercard
          amex
        }

        cardNetworkStatus {
          VISA {
            cardNetwork
            logo
          }

          AMEX {
            cardNetwork
            logo
          }

          MASTERCARD {
            cardNetwork
            logo
          }
        }
      }

      pagination {
        nextOffset
        pageSize
        hasNextPage
      }
    }
  }
`;

export default GET_MERCHANTS;
